import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IMenuReq } from '../../../../models/menus.model'
import { doCreateSubmenu } from '../../../../store/menu.slice';
import { doRemoveAuth } from '../../../../store/auth.slice';
import { RootState } from '../../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../../components/Loader';
import SimpleHeader from '../../../../components/layout/SimpleHeader';
import Footer from '../../../../components/layout/Footer';
import Editor from '../../../../components/system/menu/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../../lib/barVariant';

interface IMatch {
  id: string;
}

const SystemMenuSubmenuCreate: FC<RouteComponentProps> = ({ history }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.group);
  
  const match = useRouteMatch<IMatch>();
  const id = Number(match.params.id);

  const onSubmit = async (req: IMenuReq) => {
    const res = await dispatch(doCreateSubmenu(id, req));
    
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create'), successVariant);
        history.push(`/system/menu/${id}/submenu`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.menu.title4')}
      />
      <Editor
        menu={null}
        onSubmit={onSubmit}
        cancelPath={`/system/menu/${id}/submenu`}
      />
      <Footer />
    </div>
  )
}

export default SystemMenuSubmenuCreate;
